// extracted by mini-css-extract-plugin
module.exports = {"comments":"CommentList_comments__2bAVJ","empty":"CommentList_empty__cQUMp","icon":"CommentList_icon__X2Y8x","loading":"CommentList_loading__3brF8"};